export default class FileHelper {
  public static readonly getBase64 = async (file: any) =>
    new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
    });

  public static readonly toBase64 = (files: any) => {
    const fileListToFormat: any = [];
    if (files.length) {
      files.forEach(async (file: any) => {
        const ObjFile = {
          name: file.name,
          file: await this.getBase64(file)
        };
        fileListToFormat.push(ObjFile);
      });
    }
    return fileListToFormat;
  };

  public static readonly convertToBase64 = (image: File) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = () => {
        if (reader.result && typeof reader.result === 'string') {
          resolve(reader.result.split(',')[1]);
        }
      };
      reader.onerror = (error) => {
        reject(new Error(`File reading error: ${error}`));
      };
    });

  public static readonly getFileExtension = (filename: string) => {
    const regex = /\.([^.]+)$/;
    const match = regex.exec(filename);
    if (!match) return '';
    return match[1];
  };
}
